import React, { FC, useEffect } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { TextInput } from "@/components/atoms";
import { RefSelectInput } from "@/components/molecules";

import { FormType } from "../../utils";

const Finance: FC = () => {
    const { control, watch, trigger, setValue, clearErrors } = useFormContext<FormType>();
    const financeAccountNumber = watch("financeAccount");
    const financeAccountType = watch("financeAccountType");
    const { t } = useTranslation();

    useEffect(() => {
        if (financeAccountType === "") {
            clearErrors();
            setValue("financeAccount", "");
            return;
        }

        if (financeAccountNumber) trigger("financeAccount");
    }, [financeAccountType]);

    return (
        <>
            <RefSelectInput name="financeAccountType" control={control} table="bankAccountType" />
            <TextInput
                name="financeAccount"
                label={t("AddFamilyMember.Finance.Account")}
                disabled={financeAccountType === ""}
                autoComplete="off"
                control={control}
            />
        </>
    );
};

export default Finance;
